"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rioMobileBorderRadius = exports.rioDesktopBorderRadius = void 0;
exports.rioDesktopBorderRadius = {
    actions: '8px',
    transactional: '19px',
    inputs: '4px'
};
exports.rioMobileBorderRadius = {
    actions: '.8rem',
    transactional: '1.9rem',
    inputs: '.4rem'
};
